/**
 * This is useful when you want to support consumers sending refs (forwardRef)
 * but you also need a ref for internal use.
 */
export function mergeRefs<T extends HTMLElement>(
    ...args: Array<React.MutableRefObject<T> | React.LegacyRef<T>>
): React.RefCallback<T> {
    return (value) => {
        args.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref != null) {
                (ref as React.MutableRefObject<T | null>).current = value;
            }
        });
    };
}
